import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, TabsContainer, ListContainer } from '../Reusable'

import FadeIn from 'react-fade-in';
import PartnerDetails from '../Admin/Partners/PartnerDetails'
import AssoContactsList from './AssoContactsList'

const { useHistory } = require('react-router-dom')

const tabs = [
  {
    title: 'Nos partenaires',
    key: 'partners',
  },
  {
    title: 'Vos demandes',
    key: 'contacts',
  },
]

interface Props {
  match: any;
}
const AssoPartnersScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)
  const tab = props.match.params.tab || tabs[0].key

  const onFetch = async () => {
    try {
      const partnersRef = Fire.store().collection('partners').where('active', '==', true)
      const list = await Fire.list(partnersRef)
      for (const item of list) {
        /*const sent = await Fire.doc(partnersRef.doc(item.id).collection('contacts').doc(user.id))
        item.sent = !!sent*/
      }
      return list
    } catch (err) {
      setError("Impossible de charger les partenaires")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  /*
  const onReach = async (item: any, refresh: any) => {
    try {
      const proRef = Fire.store().collection('pros').doc(item.id)
      await proRef.collection('contacts').doc(user.id).set({
        createdAt: new Date(),
      })
      refresh()
    } catch (err) {
      setError("Impossible de contacter le partenaire actuellement")
      console.warn(err)
    }
  }*/

  const renderContent = () => {
    if (tab === 'contacts')
      return (<AssoContactsList />)
    return (
      <ListContainer
        title="Nos partenaires"
        searchTitle="Rechercher un partenaire..."
        error={error}
        onFetch={onFetch}
        sorting={sorting}
        renderColumns={({ refresh }) => ([
          { name: 'Image', accessor: 'image', cell: (item) => (
            <div className="table-preview">
              {item.pictures && item.pictures.length &&
                <img alt={item.name} src={item.pictures[0]} />
              }
            </div>
          ) },
          { name: 'Nom', sortable: true, accessor: 'name' },
          { name: 'Actions', accessor: 'actions', hasButton: true, cell: (item) => (
            <div>
              <ConfirmButton
                title={'Contacter'}
                noConfirm
                confirmTitle={'Souhaitez-vous envoyer un email ' + item.mail + ' pour contacter notre partenaire ?'}
                onPress={(e) => {
                  e.stopPropagation();
                  window.location.href = "mailto:" + item.mail;
                  //history.push('/contact/' + item.id)
                }} />
            </div>
          )},
        ])}
        expandableRow={(item: any, { refresh }) => (
          <PartnerDetails data={item} refresh={refresh} />
        )}
        />
    )
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={'Annuaire'}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            {/*}
            <TabsContainer
              tab={tab}
              tabs={tabs}
              onSelect={(tab) => history.push('/partners/' + tab.key)}
              />
            */}

            <FadeIn key={'fade-' + tab}>
              {renderContent()}
            </FadeIn>

          </div>
        </div>
      </div>
    </div>
  );
}

export default AssoPartnersScreen